// extracted by mini-css-extract-plugin
export var emptyState = "_51-d";
export var statCard = "_51-c";
export var table = "_51-0";
export var tableCell = "_51-4";
export var tableCellClickable = "_51-5 _51-4";
export var tableCellDefault = "_51-6 _51-4";
export var tableCellEmpty = "_51-8";
export var tableCellWithValue = "_51-7";
export var tableContainer = "_51-e";
export var tableHeaderWeight = "_51-1";
export var tableHeaderZone = "_51-2";
export var tableRowHeader = "_51-3";
export var viewModeButton = "_51-9";
export var viewModeButtonActive = "_51-a _51-9";
export var viewModeButtonInactive = "_51-b _51-9";